import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import LandingHeader from "./components/LandingHeader";
import { HeroSection } from './components/Herosection';
import AboutSection from './components/Aboutsection';
import { ServicesSection } from './components/Servicessection';
import { FaqSection } from './components/FaqSection';
import { CtaSection } from './components/CtaSection';
import { LandingFooter } from './components/LandingFooter';
import Login from './auth/Login';
import NotFound from './components/NotFound';
import { DashboardLayout } from './dashboard/admin/inc/DashboardLayout';
import AdminHome from './dashboard/admin/AdminHome';
import ManageCustomer from './dashboard/admin/ManageCustomer';
import CustomerPermissions from './dashboard/admin/CustomerPermissions';
import ManageProducts from './dashboard/admin/ManageProducts';
import ManageShop from './dashboard/admin/ManageShop';
import ShopDetailView from './dashboard/admin/ShopDetailView';
import ManagePermissionA from './dashboard/admin/ManagePermisionA';
import ChangePassword from './dashboard/admin/ChangePassword';
import UserLogs from './dashboard/admin/UserLogs';
import UserActivityDetails from './dashboard/admin/UserActivityDetails';
import ManageUser from './dashboard/admin/ManageUser';
import OwnerDashboardLayout from './dashboard/shopOwner/inc/OwnerDashboardLayout';
import ResetPassword from './auth/ResetPassword';
import DashboardRouter from './dashboard/shopOwner/DashboardRouter';
import ManageProductO from './dashboard/shopOwner/ManageProductO';
import ManageShopO from './dashboard/shopOwner/ManageShopO';
import ManageStockO from './dashboard/shopOwner/ManageStockO';
import ManageSaleO from './dashboard/shopOwner/ManageSaleO';
import ManageSellerO from './dashboard/shopOwner/ManageSellerO';
import ManagePaymentO from './dashboard/shopOwner/ManagePaymentO';
import MyProfile from './dashboard/shopOwner/MyProfile';
import ChangePasswordO from './dashboard/shopOwner/ChangePasswordO';
import ManageNotificationO from './dashboard/shopOwner/ManageNotificationO';
import ShopDetails from './dashboard/shopOwner/shop/ShopDetails';
import MyProfileA from './dashboard/admin/MyProfileA';


function App() {
  return (
    <Routes>
      {/* Landing Page */}
      <Route path="/" element={
        <div className="App">
          <LandingHeader />
          <HeroSection />
          <AboutSection />
          <ServicesSection />
          <FaqSection />
          <CtaSection />
          <LandingFooter />
        </div>
      } />

      {/* Login Page */}
      <Route path="/login" element={<Login />} />
      <Route path="/resetPassword" element={<ResetPassword />} />

      {/* Admin Dashboard - Protected */}
      <Route
        path="/app"
        element={
          <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminHome />} />
        <Route path="customers" element={<ManageCustomer />} />
        <Route path="customers/:customerId/permissions" element={<CustomerPermissions />} />
        <Route path="products" element={<ManageProducts />} />
        <Route path="shops" element={<ManageShop />} />
        <Route path="shops/:shopId" element={<ShopDetailView />} />
        <Route path="users" element={<ManageUser />} />
        <Route path="permissions" element={<ManagePermissionA />} />
        <Route path="users/:userId" element={<ManageUser />} />
        <Route path="userLogs" element={<UserLogs />} />
        <Route path="userLogs/:userlogId" element={<UserActivityDetails />} />
        <Route path="profile" element={<MyProfileA />} />
        <Route path="changePassword" element={<ChangePassword />} />
      </Route>

      {/* Shop Owner / Seller Dashboard - Protected */}
      <Route
        path="/shop"
        element={
          <ProtectedRoute allowedRoles={['owner', 'seller']}>
            <OwnerDashboardLayout />
          </ProtectedRoute>
        }
      >
        {/* <Route index element={<OwnerHome />} /> */}
        <Route index element={<DashboardRouter />} />
        <Route path="products" element={<ManageProductO />} />
        <Route path="shops" element={<ManageShopO />} />
        <Route path="shopDetails/:shopId" element={<ShopDetails />} />
        <Route path="stocks" element={<ManageStockO />} />
        <Route path="sales" element={<ManageSaleO />} />
        <Route path="sellers" element={<ManageSellerO />} />
        <Route path="payment" element={<ManagePaymentO />} />
        <Route path="profile" element={<MyProfile />} />
        <Route path="changePassword" element={<ChangePasswordO />} />
        <Route path="notification" element={<ManageNotificationO />} />
      </Route>

      {/* 404 – Catch all (MUST be last) */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;